import React from 'react';
import '../../styles/components/AsperaErrorState.scss';
import { ImageErrorDefault } from '../../svg/ImageErrorDefault';
import { ImageErrorForbidden } from '../../svg/ImageErrorForbidden';
import { ImageErrorNotFound } from '../../svg/ImageErrorNotFound';
import { clearStorageItems, downloadSupportData } from '../../helpers/starterHelpers';
import { openAppInfoModal } from '../../helpers/components';
import { language } from '../../services/LanguageService';
import { SubManager } from '../../classes/SubManager';
import { Button, Link } from '../Carbon';
/**
 * React Component
 *
 * The AsperaErrorState provides the error state to render on UI (mostly critical page errors or DataTable errors)
 *
 * @example
 * ```javascript
 * <AsperaErrorState title={'My title'} body={'My body text'} />
 * ```
 */
export class AsperaErrorState extends React.Component {
    constructor() {
        super(...arguments);
        this.subManager = new SubManager();
    }
    get image() {
        const { type } = this.props;
        switch (type) {
            case '404':
                return React.createElement(ImageErrorNotFound, null);
            case '403':
                return React.createElement(ImageErrorForbidden, null);
            default:
                return React.createElement(ImageErrorDefault, null);
        }
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { title, body, description, links, className, smallRender, buttons } = this.props;
        let linksToUse = links;
        if (!linksToUse) {
            linksToUse = [
                {
                    name: language.get('header.refresh'),
                    onClick: () => {
                        window.location.reload();
                    },
                },
                {
                    name: language.get('header.resetSession'),
                    onClick: () => {
                        clearStorageItems();
                        window.location.reload();
                    },
                },
                {
                    name: language.get('header.getDebuggingInfo'),
                    onClick: () => {
                        openAppInfoModal(this.subManager);
                    },
                },
                {
                    name: language.get('header.downloadSupportData'),
                    onClick: () => {
                        downloadSupportData();
                    },
                },
            ];
        }
        return (React.createElement("div", { className: `aspera-error-state ${className ? className : ''} ${smallRender ? 'small-render' : ''}`, "data-auto": "aspera-error-state" },
            React.createElement("div", { className: "text-area" },
                React.createElement("div", { className: "primary-text" }, title),
                React.createElement("div", { className: "secondary-text" }, body),
                !!description && React.createElement("div", { className: "description-text" }, description),
                Array.isArray(buttons) && buttons.filter(button => !button.hidden).map((button, index) => React.createElement("div", { className: "button", key: index },
                    React.createElement(Button, { kind: button.kind, renderIcon: button.icon, "data-auto": `error-state-${button.name}`, onClick: button.onClick }, button.name))),
                Array.isArray(linksToUse) && linksToUse.map((link, index) => React.createElement("div", { className: "link", key: index },
                    React.createElement(Link, { onClick: link.onClick }, link.name)))),
            React.createElement("div", { className: "image-area" }, this.image)));
    }
}
